'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}let

SortExtensions=function(){
function SortExtensions(sortFn){_classCallCheck(this,SortExtensions);
this._sortFn=sortFn;
}SortExtensions.prototype.

invert=function invert(){var _this=this;
return function(item){return-1*_this._sortFn(item)};
};SortExtensions.

extend=function extend(sortFn){
return new SortExtensions(sortFn);
};return SortExtensions}();


module.exports=SortExtensions.extend;
//# sourceMappingURL=sortExtensions.js.map
